module.exports = require("@nestjs/platform-express/multer/interceptors/file.interceptor");